import { SpinnerOver } from "./Spinner";
import { PropTypes } from "prop-types";
const Button = ({ text, onClick, className, isPending, type }) => {
  const baseClass =
    "bg-blue-500 hover:bg-blue-700 text-white py-1 px-3 rounded";
  const disabledStyle = "opacity-50 pointer-events-none";

  return (
    <span className="p-0">
      {isPending ? (
        <SpinnerOver>
          <button
            onClick={onClick}
            className={`${baseClass} ${disabledStyle} ${className}`}
            disabled={isPending}
            type={type}
          >
            {text}
          </button>
        </SpinnerOver>
      ) : (
        <button
          onClick={onClick}
          className={`${baseClass} ${className ? className : ""}`}
          type={type}
        >
          {text}
        </button>
      )}
    </span>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  isPending: PropTypes.bool,
  type: PropTypes.string,
};

export const OutlineButton = ({ text, onClick, className }) => {
  const outlineStyle =
    "border border-blue-500 hover:border-blue-700 text-blue-500 hover:text-blue-700 py-1 px-3 rounded";

  OutlineButton.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
  };

  return (
    <span className="pt-2">
      <button onClick={onClick} className={` ${outlineStyle} ${className}`}>
        {text}
      </button>
    </span>
  );
};

export default Button;
